import { Injectable } from '@angular/core';
import { Observable,  } from 'rxjs';
import { MessageService } from '../message.service';
import { HttpClient }from '@angular/common/http';
import { ProjectType, PagedResponseProjectType } from '../models/ProjectType';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})



export class ProjectTypeService {
  readonly APIURL = environment.APIURL;
  constructor(private messageService:MessageService, private http:HttpClient) { }



  getProjectTypes():Observable<PagedResponseProjectType>{
    const data =  this.http.get<PagedResponseProjectType>(this.APIURL+'/ProjectType' + '?PageNumber=1&PageSize=100');
    this.messageService.add('ProjectType Service: fetched ProjectTypes');
    return data;
  }

  getProjectType(id: number): Observable<ProjectType> {
        const ProjectType =this.http.get<ProjectType>(this.APIURL+'/ProjectType/' + id);
    this.messageService.add(`ProjectType Service: fetched ProjectType with id=${id}`);
    return ProjectType;
  }
}